import { memo, useEffect, useState, FC } from "react";
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Textarea,
} from "@chakra-ui/react";
import { OrionRegistration } from "../../../types/api/orionRegistration";

type Props = {
  Registration: OrionRegistration | undefined;
  isOpen: boolean;
  onClose: () => void;
};

export const OrionRegistrationModal: FC<Props> = memo((props) => {
  const { isOpen, onClose, Registration } = props;

  useEffect(() => {
    onModalReset();
  }, [Registration]);

  const onModalReset = () => {
    if (Registration) {
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        onModalReset();
        onClose();
      }}
      motionPreset="slideInBottom"
      autoFocus={false}
      size={"4xl"}
    >
      <ModalOverlay />
      <ModalContent pb={2}>
        <ModalHeader>Registration状況</ModalHeader>
        <ModalCloseButton />
        <ModalBody mx={{ base: 0, md: 6 }}>
          <Textarea
            value={JSON.stringify(Registration, null, 2)}
            readOnly={true}
            rows={20}
            border="1px"
            borderColor={"gray.400"}
          />
        </ModalBody>
        <ModalFooter></ModalFooter>
      </ModalContent>
    </Modal>
  );
});
